<template>
  <div id="app" class="">
    <div class="app-main">
      <div class="app_container">
        <div class="single_content">
          <div class="course_buy_info">
            <div class="app_header">
              <div class="app_header_left">
                <i class="el-icon font24 cp" @click="goFor">
                  <svg
                    viewBox="0 0 1024 1024"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="currentColor"
                      d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
                    ></path>
                  </svg>
                </i>
                <div class="course_title tx-ov">{{ majorName }}</div>
                <div class="icon_btn_list" v-if="majorName">
                  <img
                    :src="like"
                    alt=""
                    class="pView_img"
                    style="margin-left: 10px"
                    @click="clickLike(false)"
                    v-if="videoLike"
                  />
                  <img
                    :src="isNotLike"
                    alt=""
                    class="pView_img"
                    style="margin-left: 10px"
                    @click="clickLike(true)"
                    v-else
                  />
                </div>
              </div>
            </div>
            <div class="app_content">
              <div class="app_video">
                <div id="player" class="video_content">
                  <div
                    class="pv-video-player pv-skin_blue-39190823 pv-skin_blue-player pv-paused"
                  >
                    <div class="pv-video-wrap">
                      <video
                        id="videoPlayer"
                        ref="player"
                        class="video-js vjs-default-skin vjs-big-play-centered"
                        preload="preload"
                        :poster="poster"
                        controlslist="nodownload"
                        controls
                        @play="onPlayerPlay($event)"
                        @ended="onPlayerEnded($event)"
                        @timeupdate="onPlayerUpdate($event)"
                        @seeking="onPlayerSeeking($event)"
                        @pause="onPlayerPause($event)"
                        @loadeddata="onPlayerLoadeddata($event)"
                        oncontextmenu="return false"
                      ></video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function throttle(fn, delay) {
  let last = 0; //上次触发时间
  return function (...args) {
    const now = Date.now();
    if (now - last > delay) {
      last = now;
      fn.apply(this, args);
    }
  };
}
import Videojs from "video.js";
import { getVideoDetail, setVideoRecord } from "../../api/moudles/home.js";
import {
  getVipUser,
  saveVideoSpeed,
  getVideoSpeed,
  toggleVideoLike,
} from "../../api/moudles/user.js";
// import md5 from "js-md5";
export default {
  name: "videoplay",
  data() {
    return {
      backPng: require("../../assets/img/webIndex/back.png"),
      fwordPng: require("../../assets/img/webIndex/fword.png"),
      like: require("@/assets/img/videoLearn/isLike.png"),
      isNotLike: require("@/assets/img/videoLearn/isNotLike.png"),
      majorName: "",
      major_id: "",
      claId: "",
      currentRate: "1x",
      scId: "",
      currentVideoId: "",
      ClassName: "pv-active",
      ClassName2: "",
      poster: "https://img.videocc.net/public/audio_default_b.png",
      videoList: [],
      nowPlayVideoUrl: "",
      isProcess: false,
      isDisplay: true,
      Style: "right: 0px",
      changeColor: "",
      player: null,
      timer: "",
      // 初始秒
      origin_time: 0,
      userStatus: "",
      memberCode: "",
      videoBack: false,
      throttleIndex: throttle(this.toIndex, 1000),
      throttleLogin: throttle(this.toLogin, 1000),
      intervalId: null,
      finallyUrl: "",
      videoLike: false,
      likeLoading: false,

      maxProgressSeconds: 0,
    };
  },
  beforeDestroy() {
    this.stopRecordProgress();
    this.newbeforeDestroy();
  },
  created() {
    this.newGetViper(() => {
      const newVideo = this.$route.params;
      console.log("newVideo", newVideo);
      if (newVideo.video) {
        // 从外部返回
        this.videoBack = true;
      }
      if (newVideo.isVip) {
        // 是否有免费时长
        if (newVideo.freeTime) {
          // 分钟*秒
          // 不完整，以播放时间为准
          // 免费时长结束
          // 检查是否登录
          // 监听播放进度（秒）
          this.timer = parseInt(newVideo.freeTime) * 60;
        }
      }
      this.videoId = newVideo.video_id;
      this.getVideoDetail(this.videoId);
    });
  },
  mounted() {
    let newConfig = JSON.parse(localStorage.dynamicConfig);
    if (newConfig.finally_url) {
      this.finallyUrl = newConfig.finally_url;
    }
  },
  methods: {
    async clickLike(flag) {
      if (this.likeLoading) {
        this.$message({
          message: "请等一下，不要频繁点击",
          type: "warning",
        });
        return;
      }
      this.likeLoading = true;
      await toggleVideoLike({
        data: {
          videoId: this.videoId,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.videoLike = flag;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        },
      });
      this.likeLoading = false;
    },
    // 启动视频进度记录
    startRecordProgress() {
      this.intervalId = setInterval(async () => {
        const video = this.$refs.player;
        const currentTime = video.currentTime; // 获取当前播放进度
        // 获取视频总时长
        const duration = video.duration;
        console.log(`Duration: ${parseInt(duration)}`);
        await saveVideoSpeed({
          data: {
            videoId: this.videoId,
            userId: this.memberCode,
            currentSeconds: parseInt(currentTime),
            maxProgressSeconds:
              this.maxProgressSeconds > parseInt(currentTime)
                ? this.maxProgressSeconds
                : parseInt(currentTime),
            durationSeconds: parseInt(duration), //总时长
          },
          success: () => {},
        });
      }, 5000);
    },
    // 停止记录进度
    stopRecordProgress() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    async newGetViper(func) {
      await getVipUser({
        success: (res) => {
          if (res.code === 200 || res.code == 0) {
            this.userStatus = res.data.status;
            this.memberCode = res.data.memberCode;
            this.$store.commit("user/SET_TOKEN_TIME", Date.now());
            localStorage.setItem("tokenTime", Date.now());
          } else {
            this.userStatus = null;
            this.memberCode = null;
            this.$store.commit("user/RESET_INFO");
          }
          func && func();
        },
      });
    },
    // 添加dom
    domInit() {
      let video = document.getElementsByClassName("video-js").videoPlayer;
      // 绘制外层div
      let newDiv = document.createElement("div");
      newDiv.className = "pass_back";
      newDiv.style.width = "70px";
      newDiv.style.justifyContent = "space-between";
      newDiv.style.display = "flex";
      newDiv.style.position = "absolute";
      newDiv.style.right = "5px";
      newDiv.style.top = "unset";
      newDiv.style.bottom = "40px";
      newDiv.style.left = "unset";
      newDiv.style.padding = "0";
      newDiv.style.cursor = "pointer";
      newDiv.style.opacity = "1";

      let newImg1 = document.createElement("img");
      let newImg2 = document.createElement("img");
      newImg1.src = this.backPng;
      newImg1.onclick = this.back;
      newImg1.title = "回进15秒";
      newImg2.src = this.fwordPng;
      newImg2.onclick = this.forward;
      newImg2.title = "快进15秒";
      newDiv.appendChild(newImg1);
      newDiv.appendChild(newImg2);

      video.appendChild(newDiv);
    },
    forward() {
      const currentTime = this.player.currentTime();

      if (this.maxProgressSeconds < currentTime) {
        this.$message.warning("未学习完成，无法跳进度！");
        this.player.currentTime(this.maxProgressSeconds);
        return;
      }

      this.player.currentTime(currentTime + 15);
    },
    back() {
      const currentTime = this.player.currentTime();
      this.player.currentTime(currentTime - 15);
    },
    // 提交视频播放记录
    async setVideoRecord(type) {
      await setVideoRecord({
        data: {
          type,
          newsId: this.videoId,
          userId: this.memberCode,
        },
      });
    },
    // 去登录
    toLogin() {
      // 未登录跳转登录
      this.$confirm("当前课程限会员使用，加入会员免费观看", "提示", {
        confirmButtonText: "立即前往",
        showClose: false,
        lockScroll: true,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        type: "info",
      }).then(() => {
        // 未登录跳转登录
        const screenWidth = window.screen.width;
        if (screenWidth < 760) {
          this.$router.push("/phoneIndex/login");
        } else {
          // http://zjxgrhy.a6edu.com
          const Url = `${this.finallyUrl}/login?isMember=true&videoDetail=true&videoId=${this.$route.params.video_id}&freeTime=${this.$route.params.freeTime}`;
          // this.$router.push("/login");
          window.location.replace(Url);
        }
      });
    },
    // 去首页
    toIndex() {
      // 未登录跳转登录
      this.$confirm("当前课程限正式会员观看", "提示", {
        confirmButtonText: "返回列表",
        showClose: false,
        lockScroll: true,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        type: "info",
      }).then(() => {
        // 跳转到首页
        this.$router.go(-1);
      });
    },
    // 视频详情
    async getVideoDetail(id) {
      await getVideoDetail({
        data: {
          id: id ? id : this.videoId,
        },
        success: (res) => {
          console.log("res", res);
          if (res.data[0]) {
            const newVideo = res.data[0];
            this.majorName = newVideo.name; //课程名称
            this.videoLike = newVideo.isLiked;
            this.initVideo(newVideo.path);
            setTimeout(() => {
              this.setVideoRecord("2");
            }, 200);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          }
        },
      });
    },
    // 播放回调
    onPlayerPlay(player) {
      console.log("player play!", player);
      if (this.memberCode) {
        this.startRecordProgress();
      }
    },
    onPlayerSeeking() {
      const video = this.$refs.player;
      const currentTime = video.currentTime; // 获取当前播放进度

      if (this.maxProgressSeconds < currentTime) {
        this.$message.warning("未学习完成，无法跳进度！");
        this.player.currentTime(this.maxProgressSeconds);
        return;
      }
    },
    // 播放中
    onPlayerUpdate(player) {
      if (this.timer) {
        let nowTime = parseInt(player.target.currentTime) - this.origin_time;
        if (nowTime > this.timer) {
          // 看看登没登录
          if (localStorage.getItem("tokenTime")) {
            const startDate = localStorage.getItem("tokenTime");
            const endDate = Date.now();
            const timeDifference = endDate - startDate;
            // 2小时等于  毫秒
            if (timeDifference > 60 * 60 * 2 * 1000) {
              this.$refs.player.pause();
              this.throttleLogin();
            } else {
              // 已登录判断会员类型
              if (this.userStatus !== 2) {
                this.$refs.player.pause();
                this.throttleIndex();
              }
            }
          } else {
            this.$refs.player.pause();
            this.throttleLogin();
          }
        }
      }
    },
    onPlayerLoadeddata(player) {
      console.log("player Loadeddata!", player);
    },
    onPlayerPause() {
      this.stopRecordProgress();
    },
    async onPlayerEnded(player) {
      console.log("player end!", player);
      this.stopRecordProgress();
      this.setVideoRecord("3");

      const video = this.$refs.player;
      const duration = video.duration;
      await saveVideoSpeed({
        data: {
          videoId: this.videoId,
          userId: this.memberCode,
          currentSeconds: parseInt(duration),
          maxProgressSeconds: parseInt(duration),
          durationSeconds: parseInt(duration), //总时长
        },
        success: () => {},
      });
    },
    initVideo(nowPlayVideoUrl) {
      // 这些options属性也可直接设置在video标签上
      let options = {};
      if (nowPlayVideoUrl.indexOf(".m3u8") == -1) {
        options = {
          autoplay: true, // 设置自动播放
          controls: true, // 显示播放的控件
          playbackRates: [1, 1.5, 2],
          sources: [
            // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
            {
              src: nowPlayVideoUrl,
              type: "video/mp4", // 告诉videojs,这是一个hls流
            },
          ],
        };
      } else {
        options = {
          autoplay: true, // 设置自动播放
          controls: true, // 显示播放的控件
          playbackRates: [1, 1.5, 2],
          sources: [
            // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
            {
              src: nowPlayVideoUrl,
              type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
            },
          ],
        };
      }
      // videojs的第一个参数表示的是，文档中video的id
      let that = this;
      const myPlyer = Videojs("videoPlayer", options, function onPlayerReady() {
        console.log("onPlayerReady 中的this指的是：", this); // 这里的this是指Player,是由Videojs创建出来的实例
        that.domInit();
      });
      this.player = myPlyer;
      if (this.videoBack) {
        this.player.currentTime(this.timer);
      } else {
        if (this.memberCode) {
          this.getLocalVideoRecoed();
        }
      }
    },
    // 获取本地视频播放记录
    async getLocalVideoRecoed() {
      await getVideoSpeed({
        data: {
          videoId: this.videoId,
          user_id: this.memberCode,
        },
        success: (res) => {
          if (res.data) {
            this.player.currentTime(parseInt(res.data.lastPositionSeconds));
            this.maxProgressSeconds = res.data.maxProgressSeconds;
          }
        },
      });
    },
    newbeforeDestroy() {
      if (this.player) {
        this.player.dispose(); // Removing Players,该方法会重置videojs的内部状态并移除dom
      }
    },
    goFor() {
      history.back(-1);
    },
  },
};
</script>

<style scoped>
>>> .vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
  display: block !important;
}

>>> .vjs-user-active .pass_back {
  display: flex !important;
  transition: all 0.4s;
}

>>> .vjs-user-inactive .pass_back {
  display: none !important;
  transition: all 0.4s;
}

>>> .video-js .vjs-big-play-button {
  font-size: 2.5em !important;
  line-height: 2.3em !important;
  height: 2.5em !important;
  width: 2.5em !important;
  -webkit-border-radius: 2.5em !important;
  -moz-border-radius: 2.5em !important;
  border-radius: 2.5em !important;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5) !important;
  border-width: 0.15em !important;
  margin-top: -1.25em !important;
  margin-left: -1.75em !important;
}

>>> .vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}

@media screen and (max-width: 750px) {
  .course_buy_info .app_header {
    padding-left: 0px !important;
  }

  #videoPlayer {
    width: 100%;
    height: calc(100vh - 194px);
  }
}

@media screen and (min-width: 750px) {
  #videoPlayer {
    width: 100%;
    height: 670px;
  }
}

.video-js {
  position: relative !important;
}

/* #app {
		position: relative;
		background-color: #f6f8fb;
		height: 100vh;
		overflow: auto;
	} */

.layui-rate,
li {
  list-style: none;
}

.app-main {
  /* height: 100vh; */
  background-color: #f6f8fb;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
}

.app_container {
  padding-bottom: 0;
}

.course_buy_info {
  width: 100%;
  /* height: 100vh; */
  position: relative;
}

.course_buy_info .app_header {
  height: 51px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
  padding-right: 10px;
  background: #ffffff;
  filter: drop-shadow(0px 5px 15px rgba(54, 41, 183, 0.06));
  position: relative;
  z-index: 995;
}

.course_buy_info .app_header .app_header_left {
  display: flex;
  align-items: center;
}

.pv-icon-volumeon:before {
  content: "󾘍";
}

.course_buy_info .app_header .app_header_left .el-icon {
  width: 30px;
  height: 30px;
  margin-right: 20px;
  cursor: pointer;
}

.font24 {
  font-size: 24px;
}

.el-icon {
  --color: inherit;
  height: 1em;
  width: 1em;
  line-height: 1em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  fill: currentColor;
  color: var(--color);
  font-size: inherit;
}

.pv-controls button {
  outline: none;
  border: 0;
  vertical-align: top;
  background-color: transparent;
  text-align: center;
  color: #fff;
  width: 34px;
  cursor: pointer;
  display: inline-block;
  height: 100%;
  font-size: 14px;
  font-family: "helvetica neue", "hiragino sans gb", "tahoma",
    "microsoft yahei ui", "microsoft yahei", "simsun", "sans-serif";
}

.pv-icon-settings:before {
  content: "󾘉";
}

.el-icon svg {
  height: 1em;
  width: 1em;
}

.pv-icon-pause:before {
  content: "󾘆";
}

.pv-icon-btn-play:before {
  content: "󾠼";
}

.course_buy_info .app_header .course_title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  max-width: 485px;
}

.tx-ov {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.course_buy_info .app_header .icon_btn_list {
  display: flex;
  align-items: center;
  margin-left: 30px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999;
}

.course_buy_info .app_header .icon_btn .pdr7 {
  padding-right: 7px;
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.course_buy_info .app_header .icon_btn + .icon_btn {
  margin-left: 30px;
}

.el-popper[data-popper-placement^="bottom"] > .el-popper__arrow {
  top: -5px;
}

.el-popper__arrow {
  position: absolute;
  width: 10px;
  height: 10px;
  z-index: -1;
}

.section-list {
  /*  z-index: 998;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #1c1f21;
    box-shadow: 0 5px 15px #3629b70f;
    width: 66px;
    height: 100%;
    padding-top: 60px;
    box-sizing: border-box;
    overflow: auto;*/

  position: absolute;
  margin-top: 51px;
  top: 0;
  z-index: 999;

  height: 100%;
  background: #14191e;
}

.section-list .operator {
  position: absolute;
  top: 50%;
  left: -50px;
  margin-top: -192px;
  width: 50px;
}

.section-list .operator .op {
  position: relative;
  height: 60px;
  line-height: 82px;
  font-size: 12px;
  text-align: center;
  color: #b5b9bc;
  background-color: #363c40;
  cursor: pointer;
  margin: 2px 0;
}

.section-list .operator .op:hover,
.section-list .operator .op.light {
  background-color: #f01400;
  color: #fff;
}

.section-list .operator .op i {
  position: absolute;
  display: block;
  font-size: 16px;
  text-align: center;
  border-radius: 3px 0 0 3px;
  top: 12px;
  width: 50px;
  height: 30px;
}

.nano {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.section-list .nano .nano-content {
  right: -17px !important;
  outline: none !important;
}

.nano .nano-content {
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 0;
  right: 0;
  bottom: 30px;
  left: 0;
}

.section-list h3 {
  color: #b5b9bc;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  margin-top: 20px;
  margin-right: 30px;
}

.section-list ul {
  margin-top: 15px;
  margin-right: 30px;
}

.section-list li.sec-title {
  padding-bottom: 9px;
}

.section-list li {
  margin-top: 5px;
}

.section-list li span {
  font-size: 14px;
  color: #787d82;
  line-height: 20px;
  text-align: left;
}

.section-list li a {
  font-size: 12px;
  color: #787d82;
  line-height: 20px;
  text-align: left;
  margin-left: 15px;
}

.section-list li i {
  float: right;
  font-size: 12px;
  line-height: 20px;
  text-align: left;
  color: #00b33b;
}

em {
  font-style: normal;
}

a:link,
:visited,
ins {
  text-decoration: none !important;
}

.nano .nano-pane {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  width: 10px;
  right: 0;
  top: 0;
  bottom: 0;
  visibility: hidden\9;
  opacity: 0.01;
  -webkit-transition: 0.2s;
  -moz-transition: 0.2s;
  -o-transition: 0.2s;
  transition: 0.2s;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

.app_menu_item {
  width: 100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  color: #999;
}

/*  .app_menu_item .iconfont {
    font-size: 24px;
  }*/
.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconfont {
  cursor: pointer;
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app_menu_item .iconfont {
  font-size: 24px;
}

.app_content {
  width: calc(100% - 0px);
  /* height: calc(100% - 66px); */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
}

.app_video {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* padding-bottom: 30px; */
  position: relative;
  background: #000000;
}

.app_video .video_stop {
  position: fixed;
  right: 366px;
  bottom: 100px;
  z-index: 99;
  max-height: 64px;
  cursor: pointer;
}

img,
video {
  max-width: 100%;
  /* height: auto; */
}

img,
canvas,
iframe,
video {
  display: block;
  vertical-align: middle;
}

.video_content {
  width: 100%;
  height: 100%;
}

.bplayer-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
  overflow: hidden;
  background-position: center center;
  background-size: cover;
}

.bplayer-wrap .bplayer-media-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bplayer-wrap .bplayer-media-wrap .bplayer-video {
  width: 100%;
  height: 100%;
  vertical-align: bottom;
}

.bplayer-wrap .bplayer-feature-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.bplayer-control-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  overflow: hidden;
  user-select: none;
  z-index: 9;
}

.bplayer-wrap.hide-controller .bplayer-control-wrap .bplayer-title {
  top: -40px;
}

.bplayer-control-wrap .bplayer-title {
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  font-size: 18px;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.15),
    rgba(0, 0, 0, 0.3)
  );
  transition: top 0.3s;
}

.bplayer-wrap.hide-controller .bplayer-control-wrap .bplayer-control-bar {
  bottom: -40px;
}

.bplayer-control-wrap .bplayer-control-bar {
  z-index: 1;
  position: absolute;
  height: 40px;
  width: 100%;
  padding: 0 5px;
  bottom: 0;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  backdrop-filter: none;
  transition: bottom 0.3s;
}

.bplayer-control-wrap .bplayer-control-bar .left,
.bplayer-control-wrap .bplayer-control-bar .right {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-shrink: 0;
  height: 100%;
  color: rgba(255, 255, 255, 0.8);
}

.bplayer-control-wrap .bplayer-control-bar .left .icon,
.bplayer-control-wrap .bplayer-control-bar .right .icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin: 0 5px;
  display: inline-block;
}

.bplayer-control-wrap .bplayer-control-bar .left .spliter,
.bplayer-control-wrap .bplayer-control-bar .right .spliter {
  display: inline-block;
  margin: 0 4px;
}

.bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar.absolute {
  position: absolute;
  left: 0;
  right: 0;
  top: -4px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-progress-bar
  .bplayer-progress-loaded {
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  left: 0;
  width: 0;
  border-radius: 0px 100px 100px 0px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-progress-bar
  .bplayer-progress-played {
  height: 100%;
  background: #1795ff;
  background: var(--brand-primary, #1795ff);
  position: absolute;
  left: 0;
  width: 0;
  border-radius: 0px 100px 100px 0px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-progress-bar
  .bplayer-show-thumbnails
  .cursor {
  position: absolute;
  left: 50%;
  width: 10px;
  transform: translateX(-50%);
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-progress-bar
  .bplayer-show-thumbnails
  .time {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  height: 24px;
  line-height: 24px;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
}

.bplayer-control-wrap .bplayer-control-bar .left,
.bplayer-control-wrap .bplayer-control-bar .right {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-shrink: 0;
  height: 100%;
  color: rgba(255, 255, 255, 0.8);
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text {
  width: 40px;
  margin: 0 5px;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text span,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text span {
  height: 32px;
  line-height: 32px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-control[data-show="0"]
  > .bplayer-option-list {
  width: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list {
  position: absolute;
  border-radius: 4px;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  overflow: hidden;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item {
  height: 36px;
  width: 100%;
  line-height: 36px;
  color: #fff;
  min-width: 72px;
  padding: 0 12px;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text {
  width: 40px;
  margin: 0 5px;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text span,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text span {
  height: 32px;
  line-height: 32px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .bplayer-control[data-show="0"]
  > .bplayer-option-list {
  width: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list {
  position: absolute;
  border-radius: 4px;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  overflow: hidden;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list.volume,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list.volume {
  width: 60px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list.volume
  .volume-value,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list.volume
  .volume-value {
  font-size: 16px;
  color: #fff;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list.volume
  .bplayer-volume-bar,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list.volume
  .bplayer-volume-bar {
  width: 8px;
  height: 140px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
  position: relative;
  margin-top: 12px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list.volume
  .bplayer-volume-bar-active,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list.volume
  .bplayer-volume-bar-active {
  width: 8px;
  background: #1795ff;
  background: var(--brand-primary, #1795ff);
  border-radius: 5px;
  position: absolute;
  bottom: 0;
  height: 98px;
  cursor: pointer;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.bplayer-control-wrap .bplayer-control-bar .left .icon,
.bplayer-control-wrap .bplayer-control-bar .right .icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin: 0 5px;
  display: inline-block;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list.settings,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list.settings {
  left: auto;
  right: 0;
  transform: translateX(0);
  font-size: 14px;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item.space-between,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item.space-between {
  justify-content: space-between;
}

.bplayer-control-wrap
  .bplayer-control-bar
  .left
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item
  .bplayer-switcher,
.bplayer-control-wrap
  .bplayer-control-bar
  .right
  .bplayer-control
  .bplayer-option-list
  .bplayer-option-item
  .bplayer-switcher {
  width: 40px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  position: relative;
  margin-left: 10px;
}

.bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
.bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.bplayer-control-wrap .bplayer-control-bar .left .icon,
.bplayer-control-wrap .bplayer-control-bar .right .icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin: 0 5px;
  display: inline-block;
}

.bplayer-control-wrap .bplayer-control-full {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.bplayer-control-wrap .bplayer-control-full .icon-center {
  display: inline-block;
  width: 128px;
  height: 128px;
  position: relative;
  top: 25px;
}

.bplayer-wrap .bplayer-feature-wrap .bplayer-info-wrap {
  pointer-events: none;
  overflow: hidden;
}

.bplayer-wrap
  .bplayer-feature-wrap
  .bplayer-info-wrap
  .bplayer-action-tip.hide {
  opacity: 0;
}

.bplayer-wrap .bplayer-feature-wrap .bplayer-info-wrap .bplayer-action-tip {
  position: absolute;
  bottom: 60px;
  left: 12px;
  padding: 6px 16px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  border-radius: 4px;
  transition: opacity 0.2s;
}

.bplayer-wrap .bplayer-feature-wrap .bplayer-debug-wrap {
  z-index: 9;
  width: 0;
  height: 0;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  color: #fff;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}

.bplayer-wrap .bplayer-feature-wrap .bplayer-debug-wrap .bplayer-debug-info {
  width: 48%;
  overflow: auto;
}

.bplayer-wrap .bplayer-feature-wrap .bplayer-custom-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}

.bplayer-wrap .bplayer-eye-protection {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  z-index: 9999;
  background-color: #ffb139;
  opacity: 0.07;
  pointer-events: none;
  transition: width 0.3s;
}

.pv-skin_blue-player.pv-paused .pv-skin-blue.pv-video-bottom {
  height: 63px;
  overflow: visible !important;
}

.pv-skin-blue.pv-video-bottom {
  height: 0;
  padding-top: 15px;
  overflow: hidden;
  transition: height 0.4s;
}

.pv-video-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  -ms-user-select: none;
  user-select: none;
  z-index: 2;
}

.pv-video-player * {
  box-sizing: border-box;
}

video.pv-video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: auto;
}

.pv-skin-blue .pv-controls {
  color: #fff;
  position: relative;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 16, 27, 0.7);
  background-clip: content-box;
}

.pv-controls {
  box-sizing: border-box;
  font-family: "helvetica neue", "hiragino sans gb", "tahoma",
    "microsoft yahei ui", "microsoft yahei", "simsun", "sans-serif";
  font-size: 14px;
}

.pv-skin-blue .pv-controls .pv-controls-left {
  font-size: 12px;
  position: absolute;
  left: 10px;
  top: 0;
  height: 48px;
}

.pv-skin-blue .pv-controls .pv-controls-left > * {
  display: inline-block;
  height: 100%;
  vertical-align: top;
  position: relative;
}

.pv-skin-blue .pv-controls .pv-time-wrap {
  line-height: 48px;
}

.pv-skin-blue .pv-controls .pv-controls-right {
  position: absolute;
  right: 10px;
  top: 0;
  height: 48px;
}

.pv-skin-blue .pv-controls .pv-controls-right > * {
  display: inline-block;
  height: 100%;
  vertical-align: top;
  position: relative;
}

.pv-skin-blue .pv-controls .pv-btn-radius button {
  padding: 0;
  font-size: 12px;
  color: #fff !important;
  white-space: nowrap;
  width: auto;
}

.pv-skin-blue .pv-controls .pv-btn-radius button > span {
  min-width: 60px;
  padding: 0 10px;
  line-height: 24px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 12px;
}

.pv-control-wrap-style {
  z-index: -1;
  opacity: 0;
}

.pv-control-wrap-style,
.pv-control-wrap-style2 {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: -4px;
  padding-bottom: 15px;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: opacity 0.5s;
}

.pv-controls * {
  box-sizing: border-box;
}

.pv-skin-blue .pv-rate-select {
  position: relative;
  width: 64px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}

.pv-skin-blue .pv-rate-select > div:first-child {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.pv-skin-blue .pv-rate-select > div {
  padding: 6px 0;
  margin-bottom: 1px;
  cursor: pointer;
  text-align: center;
}

.pv-skin-blue .pv-setting-select-wrap {
  min-width: 168px;
  right: -30px;
  left: auto !important;
  -ms-transform: translateX(0) !important;
  transform: translateX(0) !important;
}

.pv-skin-blue .pv-setting-select {
  font-size: 12px;
  position: relative;
}

.video-active {
  color: #3d7fff;
}

.pv-skin-blue .pv-setting-select > div:first-child {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.pv-skin-blue .pv-setting-select .pv-setting-tip {
  color: #8f8f8f;
  margin-bottom: 6px;
}

.pv-skin-blue .pv-setting-choose.pv-subtitle-select {
  min-width: 250px;
}

.pv-skin-blue.pv-subtitle-hide .pv-stream-select-wrap {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.pv-skin-blue.pv-stream-hide .pv-stream-select-wrap {
  display: none !important;
}

.pv-skin-blue .pv-setting-select .pv-setting-choose > span {
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}

.pv-skin-blue.pv-stream-hide.pv-subtitle-hide .pv-stream-select-wrap + div {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.pv-fullscreen-tip,
.pv-fullscreen-page-tip,
.pv-pip-tip {
  margin-bottom: 11px;
  font-size: 12px;
  line-height: 30px;
  padding: 0 9px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
}

.pv-fullscreen-page-wrap,
.pv-pip-wrap {
  display: none !important;
}

.pv-dm-wrap > button {
  display: none;
  font-size: 15px;
  padding-left: 7px;
  padding-right: 7px;
  width: 28px;
}

.pv-danmu-tip {
  margin-bottom: 11px;
  font-size: 12px;
  line-height: 30px;
  padding: 0 9px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
}

.pv-skin-blue .pv-volume-slider {
  position: relative;
  padding: 9px 13px;
  cursor: pointer;
  border-radius: 4px;
}

img,
video {
  max-width: 100%;
  height: auto;
}

.pView_img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

img,
canvas,
iframe,
video {
  display: block;
  vertical-align: middle;
}

/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/*滚动条的滑块*/
::-webkit-scrollbar-thumb {
  background-color: rgb(185, 221, 255);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(24, 144, 255, 0.8);
}
</style>
